import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import CloseIcon from '@mui/icons-material/Close';
import { AXIOS_API_INSTANCE } from "../Constants"
import { send_authorized_request } from "../Constants/cognito"
import { useSnackbar } from 'notistack';
import { Box, IconButton, Stack, Typography } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { LoadingBackdropIndeterminate } from "./LoadingBackdrop"
import { MuiTelInput } from "mui-tel-input"
import { MaterialUISwitchTextEmail } from "../Utils/MaterialUISwitch"

export default function CustomerContactModal({
    customer,
    customerContact,
    creatingNew,
    open,
    closeModal,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [my_customerContact, setMy_customerContact] = React.useState(customerContact)
    const [saving, setSaving] = React.useState(false)

    const handleChange = (prop) => (event, extra) => {
        if (['phone'].includes(prop)) {
            if (extra.nationalNumber !== null && extra.nationalNumber !== undefined && extra.nationalNumber.length < 11) {
                setMy_customerContact({ ...my_customerContact, [prop]: extra.nationalNumber })
            }
        } else {
            setMy_customerContact({ ...my_customerContact, [prop]: event.target.value })
        }
    }

    const save = (event) => {
        setSaving(true)
        send_authorized_request(() => {
            if (creatingNew) {
                AXIOS_API_INSTANCE.put(`customercontacts`, my_customerContact).then((customerContact) => {
                    setSaving(false)
                    enqueueSnackbar('Successfully created contact', { variant: 'success' })
                    closeModal(customerContact.data.data)
                }).catch((error) => {
                    setSaving(false)
                    enqueueSnackbar(`Failed to create contact <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            } else {
                AXIOS_API_INSTANCE.post(`customercontacts/${my_customerContact.id}`, my_customerContact).then((customerContact) => {
                    setSaving(false)
                    enqueueSnackbar('Successfully updated contact', { variant: 'success' })
                    closeModal(customerContact.data.data)
                }).catch((error) => {
                    setSaving(false)
                    enqueueSnackbar(`Failed to update contact <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            }
        })
    }

    React.useEffect(() => {
        if (open) {
            setMy_customerContact(customerContact)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    return (
        (<Dialog
            open={open}
            onClose={() => closeModal(false)}
            maxWidth={'md'}
            fullWidth
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <LoadingBackdropIndeterminate
                open={saving}
                text={"Saving Contact"}
            />
            <DialogTitle>
                <span style={{ "paddingRight": "24px" }}>Customer Contact</span>
                <IconButton
                    aria-label="close"
                    onClick={() => closeModal(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Box>
                    <Grid container spacing={2} sx={{ minWidth: '300px' }}>
                        <Grid size={6}>
                            <TextField
                                margin="dense"
                                id="first_name"
                                label="First Name"
                                type="text"
                                fullWidth
                                variant="filled"
                                value={my_customerContact?.first_name}
                                onChange={handleChange("first_name")}
                            />
                        </Grid>
                        <Grid size={6}>
                            <TextField
                                margin="dense"
                                id="last_name"
                                label="Last Name"
                                type="text"
                                fullWidth
                                variant="filled"
                                value={my_customerContact?.last_name}
                                onChange={handleChange("last_name")}
                            />
                        </Grid>
                        <Grid size={6}>
                            <MuiTelInput
                                margin="dense"
                                id="phone"
                                label="Phone"
                                type="tel"
                                inputMode="numeric"
                                fullWidth
                                variant="filled"
                                value={`+1 ${my_customerContact?.phone}`}
                                onChange={handleChange("phone")}
                                onlyCountries={['US']}
                                defaultCountry="US"
                                forceCallingCode
                                disableDropdown
                            />
                        </Grid>
                        <Grid size={6}>
                            <TextField
                                margin="dense"
                                id="email"
                                label="Email"
                                type="email"
                                fullWidth
                                variant="filled"
                                value={my_customerContact?.email}
                                onChange={handleChange("email")}
                            />
                        </Grid>
                        <Grid container spacing={1} alignItems={'center'} size={12}>
                            <Grid size="auto">
                                <span>Communication Preference:</span>
                            </Grid>
                            <Grid size="grow">
                                <Stack direction="row" component="label" alignItems="center" justifyContent="flex-begin">
                                    <Typography sx={{ fontWeight: 'bold' }}>Text</Typography>
                                    <MaterialUISwitchTextEmail onChange={(e) => setMy_customerContact({ ...my_customerContact, preferred_communication_type: e.target.checked ? 'email' : 'text' })} checked={my_customerContact?.preferred_communication_type === 'email'} />
                                    <Typography sx={{ fontWeight: 'bold' }}>Email</Typography>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
            <DialogActions>
                <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                    <Grid size="auto">
                    </Grid>
                    <Grid size="auto">
                        <Button variant="contained" autoFocus onClick={save}>
                            {creatingNew ? 'Add' : 'Update'}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>)
    );
}
